import { handleModalKeydown } from "../utils";
export default class MoreInfoModal {
    constructor() {
        this._trigger = null;
        this.openModal = (e) => {
            const trigger = e.currentTarget;
            const title = trigger.getAttribute("data-title") ?? "";
            const content = trigger.getAttribute("data-content") ?? "";
            this.open(trigger, title, content);
        };
        this.open = (trigger, title, content) => {
            if (!this._modal) {
                return;
            }
            this._trigger = trigger;
            this._modalTitle.innerHTML = title;
            this._modalContent.innerHTML = content;
            this._modal.addEventListener("keydown", this.handleKeydown);
            this._modal.removeAttribute("hidden");
            this._modal.focus();
        };
        this.closeModal = () => {
            this._modal.setAttribute("hidden", "true");
            this._trigger.focus();
            this._modalTitle.innerHTML = "";
            this._modalContent.innerHTML = "";
            this._trigger = null;
            this._modal.removeEventListener("keydown", this.handleKeydown);
        };
        this.handleKeydown = (e) => {
            const buttons = this._modal.querySelectorAll("button");
            const first = buttons[0];
            const last = buttons[buttons.length - 1];
            handleModalKeydown(e, first, last, this.closeModal);
        };
        this._modal = document.getElementById("moreInfoModal");
        if (!this._modal) {
            console.warn("#moreInfoModal was not found.");
            return;
        }
        this._modalTitle = document.getElementById("moreInfoModalLabel");
        this._modalContent = document.getElementById("moreInfoModalContent");
        this.initialize();
    }
    initialize() {
        // These buttons are using jQuery Bootstrap to open this modal, but there are many problems with that
        // Doing it properly here so all we need to change is the selector in the future
        const triggers = document.querySelectorAll("[data-target='#moreInfoModal']");
        for (const trigger of triggers) {
            trigger.addEventListener("click", this.openModal);
        }
        const closeButtons = this._modal.querySelectorAll("button.close");
        for (const btn of closeButtons) {
            btn.addEventListener("click", this.closeModal);
        }
    }
}
